import { Area, AreaContent } from "../../useAreas/areas/types";

const data: AreaContent = {
  id: Area.ALLGEMEINESZIVILRECHT,
  content: [
    "Wir beraten und vertreten Sie umfassend im Bereich des allgemeinen Zivilrechts. Dazu gehören insbesondere vertragliche Ansprüche, Leistungsstörungen, Gewährleistungsfragen und die rechtliche Prüfung oder Gestaltung von Verträgen.",
    "Das allgemeine Zivilrecht betrifft viele alltägliche und wirtschaftliche Rechtsfragen. Wir unterstützen Sie dabei, Ansprüche zu prüfen, durchzusetzen oder unberechtigte Forderungen abzuwehren.",
    "Unser Leistungsspektrum umfasst insbesondere:",
    [
      "Kauf- und Werkvertragsrecht",
      "Dienstvertragsrecht",
      "Leasingvertragsrecht",
      "Gewährleistungs- und Garantieansprüche",
      "Beratung und Abwehr bei vertraglichen Streitigkeiten",
      "Rücktritt",
      "Minderung",
      "Schadenersatz",
      "Widerruf",
      "Kündigung",
      "Vertragsgestaltung",
      "AGB",
    ],
  ],
  bullets: [
    "Kauf- und Werkvertragsrecht",
    "Dienstvertragsrecht",
    "Leasingvertragsrecht",
    "Gewährleistungs- und Garantieansprüche",
    "Beratung",
    "Abwehr",
    "Rücktritt",
    "Minderung",
    "Schadenersatz",
    "Widerruf",
    "Kündigung",
    "Vertragsgestaltung",
    "AGB",
  ],
  more: [],
};

export default data;
